export default "__VITE_ASSET__6a7f3764__"